import { Component, ElementRef, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-input-error',
  standalone: false,
  templateUrl: './input-error.component.html',
  styleUrl: './input-error.component.scss'
})
export class InputErrorComponent {
  @Input() control: AbstractControl | null = null;
  @Input() inputElement?: ElementRef; // referencia al input
  private sub?: Subscription;

  ngAfterViewInit(): void {
    if (this.control && this.inputElement) {
      this.sub = this.control.statusChanges.subscribe(() => {
        const el = this.inputElement?.nativeElement as HTMLElement;
        if (this.control?.invalid && this.control?.touched) {
          el.classList.add('p-invalid');
        } else {
          el.classList.remove('p-invalid');
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
